module.exports = __webpack_public_path__ + "img/25_2.67ed41c0.png";